if (!customElements.get('product-recommendations')) {
	customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      let cb=null
      document.addEventListener('cartCenterChange', (e) => {
        console.log('收到事件:cartCenterChange', e.detail);
        if(cb){
          cb(e.detail)
        }
      })
      $(document).on('click', 'product-recommendations .quick-add__submit', function() {
        cb=function(){
          $('cart-drawer')[0].open()
          cb=null
        }
        var rawVariant = $(this).data('variant')
        var variant = window.parseJsonAttribute
          ? window.parseJsonAttribute(rawVariant)
          : (typeof rawVariant === 'string' ? JSON.parse(rawVariant.replace(/`/g,'"')) : rawVariant)
        if (!variant) {
          console.error('Product recommendation variant data is invalid:', rawVariant)
          cb = null
          return
        }
        if(!variant.featured_image){
          variant.featured_image = $(this).data('img')
        }

      	cartCenter.add({
          id:$(this).attr('vid'),
          quantity:1,
          newProduct:variant
        })
      })
    }

    connectedCallback() {
      // const handleIntersection = (entries, observer) => {
      //   if (!entries[0].isIntersecting) return;
      //   observer.unobserve(this);
      //   fetch(this.dataset.url)
      //     .then(response => response.text())
      //     .then(text => {
      //       const html = document.createElement('div');
      //       html.innerHTML = text;
      //       const recommendations = html.querySelector('product-recommendations');

      //       if (recommendations && recommendations.innerHTML.trim().length) {
      //         this.innerHTML = recommendations.innerHTML;
      //       }

      //       if (html.querySelector('.recommendation-list')) {
      //         this.classList.add('product-recommendations--loaded');
      //       } else {
      //         this.classList.add('hidden');
      //       }
      //     })
      //     .catch(e => {
      //       console.error(e);
      //       this.classList.add('hidden');
      //     });
      // }

      // new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  });
}
